import {
  Stat,
  StatLabel,
  StatNumber,
  Button,
  Stack,
  Skeleton,
  Link,
  Alert,
  AlertTitle,
  AlertIcon,
  Checkbox,
  Box,
} from '@chakra-ui/react'
import SupportLoginCell from 'src/components/SupportLoginCell'
import { useState } from 'react'
import { selectText } from 'src/lib/utils'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query getSchoolSites($id: Int!) {
    school(id: $id) {
      id
      sites {
        id
        label
        hostname
        isPrivate
        deleted
      }
    }
  }
`

export const beforeQuery = (props) => {
  const id = Number(props.id)
  return { variables: { id }, fetchPolicy: 'cache-first' }
}

export const Loading = () => (
  <Stack>
    <Skeleton height="20px" />
    <Skeleton height="20px" />
    <Skeleton height="20px" />
  </Stack>
)

export const Empty = () => <div>Empty</div>

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ school }) => {
  const [loginDS, setLoginDS] = useState({})
  const [loginAsCMSUserDS, setLoginAsCMSUserDS] = useState({})
  const [showDeleted, setShowDeleted] = useState(false)

  const customStyle = {
    padding: '0.75rem',
    borderWidth: '1px',
    borderRadius: '12px',
    marginBottom: '5px',
  }
  let rightArrow = '\u2794'
  const allSites = school.sites ?? []
  const deletedCount = allSites.filter((s) => s.deleted === true).length
  const sites = showDeleted
    ? allSites
    : allSites.filter((s) => s.deleted !== true)

  if (!allSites.length) {
    return (
      <Alert
        status="warning"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Empty page looks bad !
        </AlertTitle>
      </Alert>
    )
  }
  return (
    <>
      {deletedCount > 0 && (
        <Box mb={3}>
          <Checkbox
            isChecked={showDeleted}
            onChange={(e) => setShowDeleted(e.target.checked)}
          >
            Show deleted sites ({deletedCount})
          </Checkbox>
        </Box>
      )}
      {sites.map((s) => (
        <Stat key={s.id} style={customStyle}>
          <StatNumber>
            {s.isPrivate ? (
              s.label
            ) : (
              <Link
                href={`https://${s.hostname}`}
                isExternal
                color="teal.500"
                style={{ textDecoration: 'none' }}
              >
                {s.label}{s.deleted ? "(deleted)" : ""}
              </Link>
            )}
          </StatNumber>
          <StatLabel
            id={`${s.id}-hostname`}
            style={{ cursor: 'pointer' }}
            onClick={(e) => selectText(e.target.id)}
          >
            {s.hostname}
          </StatLabel>
          {loginDS[s.id] === s.id
            ? s.isPrivate && (
              <SupportLoginCell
                id={school.id}
                site={s}
                label="Log in"
                from="schoolSitesCell"
              />
            )
            : s.isPrivate && (
              <Button
                colorScheme="teal"
                marginRight={2}
                marginTop={4}
                onClick={(e) => {
                  e.preventDefault()
                  setLoginDS({ [s.id]: s.id })
                  setTimeout(() => {
                    setLoginDS({})
                  }, 3000)
                }}
                variant="outline"
              >
                Log in {rightArrow}
              </Button>
            )}

          {loginAsCMSUserDS[s.id] === s.id ? (
            <SupportLoginCell
              id={school.id}
              site={s}
              returnTo={true}
              label="CMS Admin"
              from="schoolSitesCell"
            />
          ) : (
            <Button
              colorScheme="teal"
              marginTop={4}
              onClick={(e) => {
                e.preventDefault()
                setLoginAsCMSUserDS({ [s.id]: s.id })
                setTimeout(() => setLoginAsCMSUserDS({}), 3000)
              }}
              variant="outline"
            >
              CMS Admin {rightArrow}
            </Button>
          )}
        </Stat>
      ))}
    </>
  )
}
